import React from "react";
import { Link } from "react-router-dom";
import {
  Card,
  CardContent,
  CardMedia,
  Grid,
  TableBody,
  Table,
} from "@material-ui/core";
import BuildColumns from "components/Global/TablePreferenceColumns/BuildColumns";
import Styles from './tileStyles';
import styled from "styled-components";
import placeholder from "lib/images/featured-image-tmp.png";

const StyledGrid = styled(Grid)`
  && {
    min-height: 50px;
    margin-right: 10px;
    margin-left: 10px;
  }
`;

const StyledCard = styled(Card)`
  && {
    min-width: 340px;
  }
`;

const StyledDiv = styled.div`
  margin-right: 10px;
  margin-left: 10px;
`;

const StyledLink = styled(Link)`
  && {    
    font-size: 22px;
  }
`;

class PrefTiles extends React.Component {
  columns = [];

  render() {
    const {
      screenPreferences,
      tableScreenElements,
      getRows,
      deal,
    } = this.props;
    
    if (!screenPreferences) return null;
    if (!deal) return null;

    let img = placeholder;
    if (deal.imageMedium) img = `${deal.imageMedium}`;

    BuildColumns(screenPreferences, tableScreenElements, this.columns);

    return (
      <Grid item sm={12} md={6} lg={3} spacing={8}>        
        <Styles>
          <StyledCard className="card">
            <CardMedia className="media" image={img}></CardMedia>
            <CardContent className="card-content pipeline-cards">
              <Grid container direction="row">
                <StyledGrid item sm={12}spacing={8}>
                  <StyledLink to={`pipeline/active/deals/${deal.id}`}>{deal.name}</StyledLink>
                </StyledGrid>
              </Grid>
                <Table>
                  <TableBody>
                    <StyledDiv>
                      {getRows(
                        deal,
                        this.columns,
                        )}
                    </StyledDiv>
                  </TableBody>
                </Table>
            </CardContent>
          </StyledCard>        
      </Styles>
      </Grid>
    );
  }
}

export default PrefTiles;
 